import { Button, Space, Text } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { SkatIntegrationStatus } from '@features/vatDeclarations/enums/skatIntegrationStatus'

import { useTrackVatDeclarationEvent } from '../../../../../../hooks/useTrackVatDeclarationEvent'
import { useSubmitToSkat } from '../../context/submitToSkatContext'
import { Steps } from '../Steps'

interface InstructionsPageProps {
  handleCancelClick: () => void
}

export const InstructionsPage = ({ handleCancelClick }: InstructionsPageProps) => {
  const { t } = useTranslation()
  const { connectionState, handleSkatHandshake } = useSubmitToSkat()
  const trackEvent = useTrackVatDeclarationEvent()

  const isLoading =
    connectionState === SkatIntegrationStatus.Redirecting || connectionState === SkatIntegrationStatus.Connecting

  const handleConnectClick = useCallback(() => {
    handleSkatHandshake()

    trackEvent('xxx - Bookkeeping - VAT - Submit VAT DK', {
      flow: 'Success',
      step: '1 - Transfer to',
      buttonClick: 'Transfer to Skat',
    })
  }, [handleSkatHandshake, trackEvent])

  const buttonCopy = {
    [SkatIntegrationStatus.Connecting]: t('skat_form.connecting'),
    [SkatIntegrationStatus.Redirecting]: t('skat_form.redirecting'),
    [SkatIntegrationStatus.Idle]: t('skat.submit_form.cta.transfer'),
  }

  return (
    <>
      <Text variant="h1">{t('skat.submit_form.header')}</Text>
      <Space size="s8" />
      <Text>{t('skat.submit_form.description')}</Text>
      <Space size="s24" />
      <Steps />
      <Space size="s24" />
      <Button icon="squareArrowOutUpRight" fullWidth onClick={handleConnectClick} loading={isLoading}>
        {buttonCopy[connectionState]}
      </Button>
      <Space size="s8" />
      <Button variant="text" fullWidth onClick={handleCancelClick}>
        {t('cancel')}
      </Button>
    </>
  )
}
